import { Component, Input } from "@angular/core";

import { TabsContainer } from "../../containers";

@Component({
  selector: "tab",
  host: {
    "[class.hidden]": "!active"
  },
  template: require('./tab.component.html'),
  styles: [require('./tab.component.scss')]
})
export class TabComponent {
  @Input() active: boolean;
  @Input() tabTitle: string;

  constructor(tabs: TabsContainer) {
    tabs.addTab(this);
  }
  getTabTitle() {
    return this.tabTitle;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/components/tabs/tab.component.ts